module.exports = __webpack_public_path__ + "static/img/fingerpay.63ef6176.png";